export default {
  title: 'Wyniki tygodniowe',
  messages_sent: 'Wiadomości wysłane',
  messages_delivered: 'Wiadomości dostarczone',
  click_rate: 'Średni wskaźnik kliknięć',
  awaiting: 'Oczekuje na potwierdzenie',
  legend: {
    sent: 'Wysłano',
    clicked: 'Kliknięto',
    delivered: 'Dostarczone',
  },
  error_messages: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
